import dayjs from "dayjs"
import { resolveMediaUrl } from "../../helpers/userAvatar"
import avatar2 from "../../assets/images/users/avatar-2.jpg"
import avatar3 from "../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../assets/images/users/avatar-4.jpg"

export const REWARDS_STATS = {
  totalXp: 8550,
  currentLevel: 7,
  levelLabel: "Rising Collaborator",
  rewardsClaimed: 12,
  totalInvites: 18,
  /** XP toward the next level threshold (shown as progress numerator). */
  currentLevelProgress: 6550,
  /** XP required to reach the next level (shown as progress denominator). */
  nextLevelXp: 10000,
  nextLevelReward: "+25 Invites",
  /** Display count in Available Rewards header (Figma). */
  availableRewardsCount: 6,
}

export const XP_ACTIVITIES = [
  {
    id: 1,
    activity: "Completed Shadow Morning Session",
    date: "June 12, 2025",
    time: "Aug 25, 2025",
    earned: 50,
  },
  {
    id: 2,
    activity: "Design Sprint Kickoff",
    date: "June 22, 2025",
    time: "Sept 5, 2025",
    earned: 100,
  },
  {
    id: 3,
    activity: "New Feature Brainstorming",
    date: "July 8, 2025",
    time: "Sept 10, 2025",
    earned: 40,
  },
  {
    id: 4,
    activity: "Team Strategy Session",
    date: "June 14, 2025",
    time: "July 19, 2025",
    earned: 8,
  },
  {
    id: 5,
    activity: "Completed Shadow Morning Session",
    date: "June 12, 2025",
    time: "Aug 25, 2025",
    earned: 20,
  },
  {
    id: 6,
    activity: "User Testing Session",
    date: "July 2, 2025",
    time: "Aug 20, 2025",
    earned: 40,
  },
  {
    id: 7,
    activity: "Quarterly Budget Planning",
    date: "June 25, 2025",
    time: "Sept 15, 2025",
    earned: 50,
  },
  {
    id: 8,
    activity: "Product Launch Review",
    date: "June 18, 2025",
    time: "Aug 1, 2025",
    earned: 20,
  },
  {
    id: 9,
    activity: "Client Feedback Session",
    date: "June 20, 2025",
    time: "Aug 10, 2025",
    earned: 80,
  },
  {
    id: 10,
    activity: "Annual Performance Review",
    date: "July 5, 2025",
    time: "Sept 25, 2025",
    earned: 40,
  },
  {
    id: 11,
    activity: "Marketing Campaign Launch",
    date: "June 28, 2025",
    time: "Aug 30, 2025",
    earned: 20,
  },
  {
    id: 12,
    activity: "Cross-Department Workshop",
    date: "July 12, 2025",
    time: "Aug 18, 2025",
    earned: 100,
  },
]

export const AVAILABLE_REWARDS = [
  {
    id: 1,
    title: "Event Ticket",
    description: "Free Entry to Partner Event",
    status: "claim",
  },
  {
    id: 2,
    title: "Workshop Seat",
    description: "Attend Coding Workshop",
    status: "claim",
  },
  {
    id: 3,
    title: "Merchandise Coupon",
    description: "Discount on Event Merchandise",
    status: "claim",
  },
  {
    id: 4,
    title: "VIP Pass",
    description: "Exclusive Access to After-Party",
    status: "claim",
  },
  {
    id: 5,
    title: "Meal Voucher",
    description: "Free Lunch at Venue",
    status: "claim",
  },
  {
    id: 6,
    title: "Merchandise Coupon",
    description: "Discount on Event Merchandise",
    status: "claim",
  },
  {
    id: 7,
    title: "Event Ticket",
    description: "Free Entry to Partner Event",
    status: "claimed",
  },
  {
    id: 8,
    title: "Networking Session",
    description: "Invitation to VIP Networking",
    status: "claim",
  },
]

export const RECENT_LEADERS = [
  { id: 1, name: "Sophia Lee", avatar: avatar2, xp: 4500 },
  { id: 2, name: "Marcus Bell", avatar: avatar4, xp: 4200 },
  { id: 3, name: "Tara Kim", avatar: avatar3, xp: 3900 },
]

/** Mock total for activity pagination (Figma: Showing 1 to 12 of 200). */
export const XP_ACTIVITIES_TOTAL = 200

export const XP_ACTIVITY_WITH = ["source"]
export const AVAILABLE_REWARDS_WITH = ["user", "reward", "medias"]
export const REWARD_DASHBOARD_TYPES = ["xp_stats", "reward_stats"]

export const EMPTY_REWARD_DASHBOARD = {
  totalXp: 0,
  currentLevel: 1,
  rewardsClaimed: 0,
  totalInvites: 0,
  hasClaimedAtCurrentLevel: false,
  progressLabel: "",
  progressPercent: 0,
}

const parsePercent = value => {
  const n = Number(String(value ?? "").replace("%", "").trim())
  return Number.isFinite(n) ? Math.min(100, Math.max(0, n)) : 0
}

export const formatLevelOrdinal = level => {
  const num = Math.max(0, Number(level) || 0)
  const mod100 = num % 100
  if (mod100 >= 11 && mod100 <= 13) return `${num}th Level`
  switch (num % 10) {
    case 1:
      return `${num}st Level`
    case 2:
      return `${num}nd Level`
    case 3:
      return `${num}rd Level`
    default:
      return `${num}th Level`
  }
}

export const mapRewardDashboardStats = result => {
  const xp = result?.xp_stats || {}
  const reward = result?.reward_stats || {}
  const totalXp = Number(reward.total_xp_earned) || 0
  const currentLevel = Number(reward.current_level) || 1

  return {
    totalXp,
    currentLevel,
    rewardsClaimed: Number(reward.rewards_claimed) || 0,
    totalInvites: Number(reward.total_invites_earned) || 0,
    hasClaimedAtCurrentLevel: Boolean(reward.has_claimed_at_current_level),
    progressLabel: String(xp.progress || "").trim(),
    progressPercent: parsePercent(xp.percentage),
  }
}

const NA = "N/A"

const XP_REASON_LABELS = {
  project_created: "Created project",
}

const humanizeReason = reason => {
  const key = String(reason || "").trim()
  if (!key) return "XP earned"
  if (XP_REASON_LABELS[key]) return XP_REASON_LABELS[key]
  return key
    .split("_")
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

const sourceName = source =>
  String(source?.name || source?.title || "").trim()

export const extractPaginatedList = payload => {
  const result = payload?.data?.result
  if (Array.isArray(result)) {
    return {
      list: result,
      total: result.length,
      perPage: result.length || 10,
    }
  }

  const list = Array.isArray(result?.data) ? result.data : []
  const total = Number(result?.total)
  const perPage = Number(result?.per_page || result?.page_size)

  return {
    list,
    total: Number.isFinite(total) ? total : list.length,
    perPage: Number.isFinite(perPage) && perPage > 0 ? perPage : list.length || 10,
    lastPage: Number(result?.last_page) || null,
  }
}

export const mapXpActivity = item => {
  const created = dayjs(item?.created_at)
  const valid = created.isValid()
  const name = sourceName(item?.source)
  const reasonLabel = humanizeReason(item?.reason)

  return {
    id: item?.id,
    activity: name ? `${reasonLabel}: ${name}` : reasonLabel,
    date: valid ? created.format("MMMM D, YYYY") : NA,
    time: valid ? created.format("h:mm A") : NA,
    earned: Number(item?.points) || 0,
  }
}

const firstRewardMediaUrl = medias => {
  const list = Array.isArray(medias) ? medias : []
  const first = list[0]
  if (!first) return null
  if (typeof first === "string") return resolveMediaUrl(first)
  return (
    resolveMediaUrl(first?.thumbnail_path_url) ||
    resolveMediaUrl(first?.path_url) ||
    resolveMediaUrl(first?.url) ||
    resolveMediaUrl(first?.image) ||
    resolveMediaUrl(first?.path) ||
    null
  )
}

const isRewardClaimed = item => {
  if (!item || typeof item !== "object") return false

  const status = String(item?.status || item?.reward?.status || "")
    .trim()
    .toLowerCase()
  const claimedFlag =
    item?.has_current_user_claimed ??
    item?.claimed ??
    item?.is_claimed ??
    item?.already_claimed
  const nested = item?.reward

  return Boolean(
    item?.claimed_at ||
      item?.redeemed_at ||
      claimedFlag === true ||
      claimedFlag === 1 ||
      claimedFlag === "1" ||
      item?.can_claim === false ||
      status === "claimed" ||
      status === "redeemed" ||
      (nested &&
        nested !== item &&
        (nested.claimed_at ||
          nested.has_current_user_claimed === 1 ||
          nested.has_current_user_claimed === true ||
          nested.is_claimed === true ||
          nested.claimed === true ||
          String(nested.status || "")
            .trim()
            .toLowerCase() === "claimed")),
  )
}

export const mapAvailableReward = item => {
  const reward = item?.reward && typeof item.reward === "object" ? item.reward : {}
  const medias = item?.medias || reward.medias || []
  const title =
    String(reward.name || reward.title || item?.name || item?.title || "")
      .trim() || "Reward"
  const description = String(
    reward.description || item?.description || ""
  ).trim()

  return {
    id: item?.id,
    claimId: item?.id,
    title,
    description,
    image: firstRewardMediaUrl(medias),
    claimed: isRewardClaimed(item),
  }
}
